export default __webpack_public_path__ + "static/media/livechat.9e2f030f.png";